/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-16 10:38:18
 * @Description: 
 */

export const useConfig = () => {
    const basePath = 'config';

    // 查询
    const GET_CHIPS_CONFIG = () => {
        const sURL = `${basePath}.getConfig`;
        // socket.emit(sURL, {}, callback);
        const res = asyncEmit(sURL, {});
        return res;
    };
    /**
     * 查询首页轮播图 
     * @param data 
     * @param callback 
     */
    const EMIT_GETROTATION = (data: any = {}, callback: any) => {
        socket.emit(`${basePath}.getRotation`, data, callback);
    };

    /**
     * 查询游戏在线人数
     * @param callback 
     * @returns closer 关闭器 
     */
    const ON_UPDATEGAMEONLINE = (callback:any) => {
        const sApi = `updateGameOnLine`;
        socket.on(sApi, callback);
        return () => socket.off(sApi, callback);
    };

    return {
        GET_CHIPS_CONFIG,
        EMIT_GETROTATION,
        ON_UPDATEGAMEONLINE,
    };
};



